import { render, staticRenderFns } from "./saveco2.vue?vue&type=template&id=273447e8&scoped=true"
import script from "./saveco2.vue?vue&type=script&lang=js"
export * from "./saveco2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273447e8",
  null
  
)

export default component.exports